import StringColumn from '@isceco/widget-library2/basic-elements/List/column/StringColumn.js'
import GenericColumn from '@isceco/widget-library2/basic-elements/List/column/GenericColumn.js'
import ImportResultRemarksCell from './ImportResultRemarksCell'

export default class ImportResultColumns {
  static getColumns() {
    return [
      ImportResultColumns.EXT_ID(),
      ImportResultColumns.STATUS(),
      ImportResultColumns.REMARKS()
    ]
  }

  static EXT_ID() {
    return new StringColumn({
      key: 'extId',
      text: 'import.result.header.extId'
    })
  }

  static STATUS() {
    return new StringColumn({
      key: 'status',
      text: 'import.result.header.status',
      translate: true
    })
  }

  static REMARKS() {
    return new GenericColumn({
      key: 'remarks',
      text: 'import.result.header.remarks',
      cell: new ImportResultRemarksCell()
    })
  }

}
